export const hrHeight = '1px';
export const hrWidth = '100%';
